import React from 'react'

export default () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.2997 5.70996C18.1129 5.5227 17.8592 5.41747 17.5947 5.41747C17.3302 5.41747 17.0766 5.5227 16.8897 5.70996L11.9997 10.59L7.10973 5.69996C6.9229 5.5127 6.66924 5.40747 6.40473 5.40747C6.14021 5.40747 5.88656 5.5127 5.69973 5.69996C5.30973 6.08996 5.30973 6.71996 5.69973 7.10996L10.5897 12L5.69973 16.89C5.30973 17.28 5.30973 17.91 5.69973 18.3C6.08973 18.69 6.71973 18.69 7.10973 18.3L11.9997 13.41L16.8897 18.3C17.2797 18.69 17.9097 18.69 18.2997 18.3C18.6897 17.91 18.6897 17.28 18.2997 16.89L13.4097 12L18.2997 7.10996C18.6797 6.72996 18.6797 6.08996 18.2997 5.70996Z" fill="black" />
    </svg>
  )
}